<template>
  <div>
    <div class="text-white p-2" @click="save()">SAVE</div>
    <VTabs :list="tabs.tabs" @change="(item)=> tabs.select(item)" />
    <div class="text-white p-2 flex w-screen overflow-auto" style="height:90vh">
      <div v-for="(typography ,i) in typos" :key="i" class="p-4" style="min-width:35rem">
        <div
          class="mb-5 font-bold rounded p-1 px-2 text-center bg-indigo-800 border inline-block"
        >{{typography.screen}}</div>
        <div class="text-white">
          <div class="flex items-end">
            <VInput
              label="Base"
              type="number"
              class="mr-2"
              v-model="typography.base"
              @change="typography.applyRatio()"
            />
            <VInput
              label="Line Height"
              type="number"
              class="mr-2"
              v-model="typography.lineHeight"
              @change="typography.applyRatio()"
            />
            <select
              v-model="typography.ratio"
              class="text-gray-800 font-roboto rounded-none"
              @change="onChangeRatio()"
              style="height:28px"
            >
              <option
                v-for="option in ratios"
                v-bind:value="option.value"
                :key="option.value"
              >{{option.value}} - {{ option.label }}</option>
            </select>
          </div>
        </div>
        <div class="overflow-auto" style="height:75vh">
          <div class="overflow-auto" style="height:50vh">
            <div v-for="(item, i) in typography.types" :key="i" class="flex items-center">
              <div
                class="transition-all transform duration-500 text-sm mr-6"
              >{{typography.getRem(item)}} ({{typography.getPx(item)}})</div>
              <div
                class="transition-all transform duration-500 font-playfair"
                :style="{fontSize:item+'px'}"
              >A Visual Type Scale</div>
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="bg-white text-gray-900 p-4 w-full mt-2">
              <h1
                :style="{fontSize:typography.first, lineHeight:typography.lineHeight }"
                class="font-playfair text-yellow-600"
              >A Visual Type Scale Title</h1>
              <h1
                class="font-roboto text-yellow-600 text-xs text-orange-800"
              >Line Height: {{typography.lineHeight}}</h1>
              <p
                :style="{fontSize:typography.last, lineHeight:typography.lineHeight}"
              >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { UUID, UiSelect, UiTabs } from "@/util";
import { mapState, mapGetters, mapActions } from "vuex";
import firebase, { firestore } from "firebase";
import {
  AppService,
  Gradient,
  GradientColor,
  BoxShadow,
  Typography
} from "../../store";
import { Component } from "../../store/models/component.model";
import ColorPicker from "vue-color-picker-wheel";
import Vue from "vue";

export default {
  name: "TypographyCreator",
  components: {
    ColorPicker
  },
  data() {
    return {
      list: [],
      all: 2,
      h1: 1,
      tabs: new UiTabs(["type", "code"]),
      typos: [
        new Typography().set({ screen: "XS" }),
        new Typography().set({ screen: "SM" }),
        new Typography().set({ screen: "MD" }),
        new Typography().set({ screen: "LG" }),
        new Typography().set({ screen: "XL" })
      ],
      ratios: [
        { value: 1.067, label: "Minor Second" },
        { value: 1.125, label: "Major Second" },
        { value: 1.2, label: "Minor Third" },
        { value: 1.25, label: "Major Third" },
        { value: 1.333, label: "Perfect Fourth" },
        { value: 1.414, label: "Augmented Fourth" },
        { value: 1.5, label: "Perfect Fifth" },
        { value: 1.618, label: "Golden Ratio" }
      ]
    };
  },
  mounted() {
    Typography.loadTypographyToDom(list => {
      this.list = list;
    });
  },
  computed: {
    ...mapState(["typographies"])
  },
  methods: {
    reset() {
      this.typos = [new Typography()];
    },
    onChange() {},
    save() {
      const stylsheet = document.createElement("style");
      stylsheet.setAttribute("type", "text/css");
      stylsheet.setAttribute("id", "typo");
      stylsheet.innerText = this.typos[0].styleSheets;
      const head = document.querySelector("head");
      console.log(this.typos[0].styleSheets);
      // head.insertBefore(head.childNodes[0],stylsheet);
      // this.typography.create().then(() => {});

    },
    update() {
      this.typography.update();
    },
    onChangeAll() {},
    onChangeRatio() {
      this.typos.forEach(item => item.applyRatio());
    }
  }
};
</script>

<style scoped>
</style>